export enum ShopAuditStatusEmun {
  PendingReview = 2111010,    // 待审核
  Approved = 2111020,   // 已通过 (你提到的状态码)
  Rejected = 2111030,   // 已拒绝
  StoreClosed = 2111040   // 已撤回
}

export enum StorageTypeEmun {
  PersonalStore = 2113010,    // 个人店铺
  EnterpriseStore = 2111020,   // 企业店铺
 
}

export enum StorageUrlTypeEmun {
  Card = 2117020,    // 身份证或护照
  BusinessLicense = 2117030,   // 企业店铺
  Passport = 2117040,
}
export enum ShopTypeEmun {
  OnlineStore = 2112010,    // 网店
  FoodStore = 2112020,   // 餐饮
  SupermarketStore = 2112030,   // 商超
  WholesaleStore = 2112040,   // 商超
}
